<template>
    <div class="zebra-crossing-detail">
        <el-form :model="configPros" ref="ruleForm"  label-width="120px" v-if="showConfigPros">
<!--            结构、MAC地址-->
            <el-row>
                <el-col :span="12">
                    <el-form-item label="结构">
                        <el-input style="width: 200px" v-model="configPros.structure"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="MAC地址">
                        <el-input style="width: 200px" v-model="configPros.mac"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="IP地址">
                        <el-input style="width: 200px" v-model="configPros.ip"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="_card-header configPro">处理器</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型">
                            <el-input style="width: 200px" v-model="configPros.cpuType"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="型号">
                            <el-input style="width: 200px" v-model="configPros.cpuModel"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="频率">
                            <el-input style="width: 200px" v-model="configPros.cpuFrequency"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="标配数量">
                            <el-input style="width: 200px" v-model="configPros.cpuStandardizedQuantity"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="最大数量">
                            <el-input style="width: 200px" v-model="configPros.cpuMaxQuantity"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="制程工艺">
                            <el-input style="width: 200px" v-model="configPros.cpuManufacturing"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="三级缓存">
                            <el-input style="width: 200px" v-model="configPros.level3Cache"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总线规格">
                            <el-input style="width: 200px" v-model="configPros.cpuBus"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="核心数">
                            <el-input style="width: 200px" v-model="configPros.cpuCoreNum"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="线程数">
                            <el-input style="width: 200px" v-model="configPros.cpuThreadNum"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            <div class="_card-header configPro">主板</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="芯片组">
                            <el-input style="width: 200px" v-model="configPros.motherboardsChip"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="扩展槽">
                            <el-input style="width: 200px" v-model="configPros.motherboardsExpansionSlot"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            <div class="_card-header configPro">内存</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型">
                            <el-input style="width: 200px" v-model="configPros.memoryType"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="容量">
                            <el-input style="width: 200px" v-model="configPros.memorySize"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="最大容量">
                            <el-input style="width: 200px" v-model="configPros.memoryMaxSize"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="插槽数量">
                            <el-input style="width: 200px" v-model="configPros.memoryExpansionSlotNum"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            <div class="_card-header configPro">存储</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘接口类型">
                            <el-input style="width: 200px" v-model="configPros.diskType"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="硬盘容量">
                            <el-input style="width: 200px" v-model="configPros.diskSize"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘描述">
                            <el-input style="width: 200px" v-model="configPros.diskDescribe"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="内部硬盘架数">
                            <el-input style="width: 200px" v-model="configPros.diskRack"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="热拔插盘位">
                            <el-input style="width: 200px" v-model="configPros.diskHotSwap"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="RAID模式">
                            <el-input style="width: 200px" v-model="configPros.diskRAID"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="硬盘控制器">
                            <el-input style="width: 200px" v-model="configPros.diskControl"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="光驱">
                            <el-input style="width: 200px" v-model="configPros.CDDrive"></el-input>
                        </el-form-item>
                    </el-col>
                 </el-row>
            <div class="_card-header configPro">网络</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="网络控制器">
                            <el-input style="width: 200px" v-model="configPros.network"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
            <div class="_card-header configPro">电源性能</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="类型">
                            <el-input style="width: 200px" v-model="configPros.powerType"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="数量">
                            <el-input style="width: 200px" v-model="configPros.powerNum"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="功率">
                            <el-input style="width: 200px" v-model="configPros.powerPower"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            <div class="_card-header configPro">外观特征</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="尺寸">
                            <el-input style="width: 200px" v-model="configPros.appearanceSize"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="重量">
                            <el-input style="width: 200px" v-model="configPros.appearanceWeight"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            <div class="_card-header configPro">适用环境</div>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="工作温度">
                            <el-input style="width: 200px" v-model="configPros.workingTemperature"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作湿度">
                            <el-input style="width: 200px" v-model="configPros.workingHumidity"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="存储温度">
                            <el-input style="width: 200px" v-model="configPros.storageTemperature"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="存储湿度">
                            <el-input style="width: 200px" v-model="configPros.storageHumidity"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
        </el-form>
        <p v-if="!showConfigPros" style="text-align:center;color: red;">此配置项无配置属性！</p>
    </div>
</template>

<script>
    export default {
        props:{
            configPros:Object,
            ruleForm:Object,
            showConfigPros:Boolean

        },
        created(){
            // console.log(1);
            // console.log(this.configPros,'configPro里的');
            // console.log(typeof this.configPros,'configPro里的');
        },
        methods:{
            innerPop(val){
                this.innerPops(val)
            },
            handleClose(tag,rows){
                this.handleCloses(tag,rows)
            }
        }

    }
</script>

<style scoped lang="scss">
    .zebra-crossing-detail .zebra-item .el-form-item__content a{
        float: left;
        margin-left: 20px;
    }
  ._card-header{
      border-bottom: 1px solid red;
      margin-left: 40px;
      width: 82%;
      padding-left: 5px;
  }
</style>
